import { render, staticRenderFns } from "./DispatchRelated.vue?vue&type=template&id=0db5fff5&scoped=true&"
import script from "./DispatchRelated.vue?vue&type=script&lang=js&"
export * from "./DispatchRelated.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=0db5fff5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5fff5",
  null
  
)

export default component.exports